module.exports = __webpack_public_path__ + "./assets/img/step5.87cb6b27.svg";